import React, { useEffect, useState } from "react";
import { Button } from "@/app/global-components/button"; // Ensure this path is correct
import { ImSpinner2 } from "react-icons/im";
import Swal from "sweetalert2";
import { useTranslate } from "@/locales";
import { useLocale } from "@/middleware";

interface TenderSubmitViewProps {
  isLoading: boolean;
}

const OfferSubmitView: React.FC<TenderSubmitViewProps> = ({ isLoading }) => {
  const { locale } = useLocale();
  const { t } = useTranslate(locale);
  const [prevLoading, setPrevLoading] = useState(isLoading);

  useEffect(() => {
    // Show SweetAlert popup when `isLoading` transitions from `true` to `false`
    if (prevLoading && !isLoading) {
      Swal.fire({
        icon: "success",
        title: t("alerts.success.offerSubmitted"),
        text: "",
        confirmButtonText: t("actions.accept"),
        timer: 3000,
        timerProgressBar: true,
      });
    }
    setPrevLoading(isLoading);
  }, [isLoading, prevLoading]);

  return (
    <div>
      <Button
        className="flex items-center bg-secondary-brightYellow shadow text-textcolor-black w-full py-2 px-4 text-sm"
        style={{ background: "#000", color: "#fff" }}
        type="submit"
        disabled={isLoading}
      >
        {isLoading ? (
          <>
            <span className="ml-2 animate-spin">
              <ImSpinner2 />
            </span>
            {t("actions.tenderSending")}
          </>
        ) : (
          t("actions.tenderSend")
        )}
      </Button>
    </div>
  );
};

export default OfferSubmitView;
